import { Channel } from 'redux-saga';
import { pickBy } from 'lodash';
import ISocketHandler from '../../../api/sockets/ISocketHandler';
import ISocketMessage from '../../../api/sockets/ISocketMessage';
import {
  CREATE_CHAIN_IN_CHAIN_LIST,
  UPDATE_CHAIN_IN_CHAIN_LIST,
} from '../../actions/chains';
import { serializeSquashedChain } from '../../serializers/chain';
import checkNullableValue from '../../../utils/checkNullableValue';

class ChainListChannelHandler implements ISocketHandler {
  socketChannel: Channel<Record<string, unknown>>;

  constructor(channel: Channel<Record<string, unknown>>) {
    this.socketChannel = channel;
  }

  public create(message: ISocketMessage) {
    const chain = serializeSquashedChain(message.data.chain);
    const createdChain = pickBy(chain, checkNullableValue);

    this.socketChannel.put({
      type: CREATE_CHAIN_IN_CHAIN_LIST,
      payload: { chain: createdChain },
    });
  }

  public delete() {
    return undefined;
  }

  public update(message: ISocketMessage) {
    const chain = serializeSquashedChain(message.data.chain);
    const updatedChainFields = pickBy(chain, checkNullableValue);
    this.socketChannel.put({
      type: UPDATE_CHAIN_IN_CHAIN_LIST,
      payload: { chain: updatedChainFields },
    });
  }

  public info() {
    return undefined;
  }
}

export default ChainListChannelHandler;
